import * as React from "react";
import { cx } from "utils/join-classnames";
import $ from "./TextArea.module.scss";

interface Props {
    onValueChanged(value: string): void;
    value?: string;
    className?: string;
    disabled?: boolean;
    placeholder?: string;
    valid?: boolean;
}

const TextArea: React.FC<Props> = ({
    value,
    className,
    onValueChanged,
    disabled,
    placeholder,
    valid,
}: Props) => (
        <textarea
            className={cx(
                $.textarea,
                !valid && valid !== undefined && $.textarea__invalid,
                className,
            )}
            onChange={(e: React.ChangeEvent<HTMLTextAreaElement>) =>
                onValueChanged(e.target.value)
            }
            disabled={disabled}
            placeholder={placeholder}
            value={value}
        />
    );
export default TextArea;
